<template>
  <v-expansion-panel-content>
    <div class="row mt-4 ml-2 " >
      <h5 class="text-center mb-5 blue--text mt-2">Число интересов в расчете:</h5>
      <div class="ml-4" style="width:220px;">
        <v-text-field outlined dense class="rank ml-2" v-model="editedItem.interests_number" :error-messages="interestErrors"
          @input="$v.editedItem.interests_number.$model = $event, onInput('interests_number')"
        />
      </div>
    </div>

    <div class="_scale-wrapper" >
      <v-data-table :headers="headersInterest" :items="editedItem.interests" :items-per-page="-1" hide-default-footer>
        <template v-slot:item.peak="{ item }">
          <v-simple-checkbox :ripple="false" :value="Boolean(item.peak)" @input="item.peak=$event" color="primary" />
        </template>
        <template v-slot:item.rank="{ item }">
            <v-text-field flat outlined dense class="rank-edit" hide-details
              v-model="item.rank" :disabled="!item.peak" :error-messages="interestRankError(item)"
            />
            <span class="error-text" v-if="interestRankError(item)">{{interestRankError(item)}}</span>
        </template>
      </v-data-table>

    </div>
    <div class="error--text error-msg">{{interestsErrors}} </div>
  </v-expansion-panel-content>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import { required, minValue } from 'vuelidate/lib/validators';
import { MESSAGES } from '@/common/constants/errorMessages';

export default {
  components: {
  },
  props: {
    editedItem: Object,
  },
  data() {
    return {
      headersInterest: [
        { text: '', sortable: false, align: 'center', value: 'peak' },
        { text: 'Наименование', align: 'start', sortable: false, value: 'name' },
        { text: 'Ранг', sortable: false, align: 'left', value: 'rank' },
      ],
    };
  },
  validations: {
    editedItem: {
      interests: { required },
      interests_number: { required, minValue: minValue(0) },
    },
  },
  computed: {
    ...mapGetters({
      errors: 'profgrams/profs/errors',
    }),
    interestsErrors() {
      return this.validationErrors('interests', { required: MESSAGES.PROF_INTERESTS_EMPTY }).join();
    },
    interestErrors() {
      return this.validationErrors('interests_number', { required: MESSAGES.REQUIRED, minValue: MESSAGES.PROF_INTERESTS_NUMBER });
    },
  },
  methods: {
    ...mapActions({
      clearError: 'profgrams/profs/clearError',
    }),
    onInput() {
      if (this.errors.create.length) this.clearError();
    },
    validationErrors(fieldName, validators) {
      const errors = [];
      for (const err of this.errors.create) {
        if (fieldName===err[0]) errors.push(...err[1]);
      }

      if (!this.$v.editedItem[fieldName].$dirty) return errors;
      for (const key in validators) {
        if (!this.$v.editedItem[fieldName][key]) {
          errors.push(validators[key]);
        }
      }
      return errors;
    },
    interestRankError (interest) {
      const { rank } = interest;
      if (+rank === 0) return;
      const identical = this.editedItem.interests.filter((el) => el.id !== interest.id).find((el) => +el.rank === +rank);
      if (identical) {
        return 'Ранг должен быть уникальным';
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.error-msg {
  height: 20px;
  font-size: 12px;
  margin-left: 10px;
}
.error-text {
   color: red;
   font-size: 8px;
}
.rank-edit {
  width: 80px;
}
</style>
